import { motion } from "framer-motion";
import { FaLinkedin } from "react-icons/fa";

interface TeamMember {
  name: string;
  role: string;
  image: string;
  email: string;
  phone: string;
  linkedin?: string;
}

const team: TeamMember[] = [
  {
    name: "Bruno Jacobos",
    role: "Diretor Executivo",
    image: "/images/team/people1.png",
    email: "bruno@nacionalgo.com.br",
    phone: "(11) 99988-8777",
    linkedin: "https://linkedin.com",
  },
  {
    name: "Mikael Barbosa",
    role: "Consultor",
    image: "/images/team/people2.png",
    email: "mikael@nacionalgo.com.br",
    phone: "(11) 99988-8777",
    linkedin: "https://linkedin.com",
  },
  {
    name: "Paulo Figueiredo",
    role: "Consultor",
    image: "/images/team/people3.png",
    email: "paulo.figueiredo@nacionalgo.com.br",
    phone: "(11) 99988-8777",
    linkedin: "https://linkedin.com",
  },
];

export const TeamSection = () => {
  return (
    <section className=" py-10 md:py-24">
      <div className="container">
        <div className="mb-12">
          <p className="text-lg text-n-green font-semibold  mb-4">
            &gt; Equipe
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold text-n-text-green mb-6 max-w-5xl">
            Conheça quem está por trás da revolução no transporte de veículos no
            Brasil.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-n-text-neutral">
          {team.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <h3 className="text-lg font-semibold">{member.name}</h3>
              <p className="text-n-text-neutral mb-4">{member.role}</p>

              <div className="flex flex-col">
                <a
                  href={`mailto:${member.email}`}
                  className="text-n-text-neutral hover:text-n-green"
                >
                  {member.email}
                </a>
                <a
                  href={`tel:${member.phone}`}
                  className="text-n-text-neutral hover:text-n-green mb-4"
                >
                  {member.phone}
                </a>
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-n-text-neutral hover:text-n-green"
                  >
                    <FaLinkedin size={20} />
                  </a>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
